export default "__VITE_ASSET__8c4d4358__"